export default "__VITE_ASSET__ms$VNKOy__"